import React from "react";
import { Grid } from "@mui/material";
import "./ApiSchemaTree.css";
import { TreeView, TreeItem } from "@mui/lab";
import TextField from "@mui/material/TextField";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import XFDLDropdown from "../../common/XFDLDropdown/XfdlDropdown";
import PropTypes from "prop-types";
/*istanbul ignore next */
const reconstructTree = (keyValueList) => {
  const result = {};
  keyValueList.forEach(({ parameterName, value }) => {
    const keys = parameterName.split(".");
    let current = result;
    keys.forEach((part, index) => {
      if (!current[part]) {
        current[part] = index === keys.length - 1 ? value : {};
      }
      current = current[part];
    });
  });
  return result;
};
/*istanbul ignore next */
const renderSourceDropdown = ({
  parameterObj,
  fullKey,
  isEditMode,
  keyValueList,
  handleSchemaValue,
  sourceDropdown,
}) => (
  <Grid item xs={3} margin={1}>
    <select
      id="Source"
      name="Source"
      className={`form-label form-control ${parameterObj?.source === 0 ? "red-outline" : ""
        }`}
      style={{ width: "100%" }}
      disabled={!isEditMode}
      value={parameterObj?.source}
      onChange={(e) => {
        const newValue = Number(e.target.value);
        const updatedList = keyValueList.map((item) =>
          item.parameterName === fullKey ? { ...item, source: newValue } : item
        );
        handleSchemaValue(updatedList);
      }}
    >
      <option selected disabled value={0}>
        Source
      </option>
      {sourceDropdown.map((option) => (
        <option key={option.key} value={option.key}>
          {option.value}
        </option>
      ))}
    </select>
  </Grid>
);
/*istanbul ignore next */
const renderClientDropdown = ({
  parameterObj,
  fullKey,
  isEditMode,
  keyValueList,
  handleSchemaValue,
  clientFolderDropdown,
  formik,
}) => (
  <Grid item xs={3.5} margin={1}>
    <select
      id="clientDetails"
      name="clientDetails"
      className={`form-label form-control ${parameterObj?.clientDetails === 0 ? "red-outline" : ""
        }`}
      style={{ width: "100%" }}
      disabled={!isEditMode}
      value={parameterObj?.clientDetails}
      onChange={(e) => {
        const newValue = Number(e.target.value);
        const updatedList = keyValueList.map((item) =>
          item.parameterName === fullKey
            ? { ...item, clientDetails: newValue }
            : item
        );
        handleSchemaValue(updatedList);
      }}
    >
      <option selected disabled value={0}>
        Select
      </option>
      {clientFolderDropdown?.map((option) => (
        <option key={option.key} value={option.key}>
          {option.value}
        </option>
      ))}
    </select>

    {formik.touched.integrationServiceRequest?.requestParameterList?.[fullKey]
      ?.clientDetails &&
      formik.errors.integrationServiceRequest?.requestParameterList?.[fullKey]
        ?.clientDetails && (
        <div style={{ color: "red", fontSize: "12px" }}>
          {
            formik.errors.integrationServiceRequest.requestParameterList[
              fullKey
            ]?.clientDetails
          }
        </div>
      )}
  </Grid>
);
/*istanbul ignore next */
const renderElabelDropdown = ({
  parameterObj,
  fullKey,
  isEditMode,
  keyValueList,
  handleSchemaValue,
  eLabelDropdown,
  formik,
}) => (
  <Grid item xs={3.5} margin={1}>
    <XFDLDropdown
      id="eLabel"
      placeholder="Select"
      width="100%"
      clearIcon="No"
      isEditMode={isEditMode}
      disabled={!isEditMode}
      dropdownWidth={500}
      options={eLabelDropdown.map((opt) => ({
        value: opt.key,
        label: opt.value,
      }))}
      dense
      placement="left-start"
      value={
        parameterObj?.eLabel
          ? [
            {
              value: parameterObj.eLabel,
              label:
                eLabelDropdown.find((o) => o.key === parameterObj.eLabel)
                  ?.value || "",
            },
          ]
          : []
      }
      setData={(selected) => {
        const newValue = selected?.value || 0;
        const updatedList = keyValueList.map((item) =>
          item.parameterName === fullKey ? { ...item, eLabel: newValue } : item
        );
        handleSchemaValue(updatedList);
      }}
      error={!parameterObj?.eLabel || parameterObj?.eLabel === 0}
    />
    {formik.touched.integrationServiceRequest?.requestParameterList?.[fullKey]
      ?.eLabel &&
      formik.errors.integrationServiceRequest?.requestParameterList?.[fullKey]
        ?.eLabel && (
        <div style={{ color: "red", fontSize: "12px" }}>
          {
            formik.errors.integrationServiceRequest.requestParameterList[
              fullKey
            ]?.eLabel
          }
        </div>
      )}
  </Grid>
);
/*istanbul ignore next */
const renderDefaultValueInput = ({
  parameterObj,
  fullKey,
  isEditMode,
  keyValueList,
  handleSchemaValue,
}) => (
  <Grid item xs={3} margin={0.9}>
    <input
      id="brandName"
      name="brandName"
      className="form-label form-control"
      type="text"
      placeholder="Default Value"
      value={parameterObj?.defaultValue}
      onChange={(e) => {
        const newValue = e.target.value;
        const updatedList = keyValueList.map((item) =>
          item.parameterName === fullKey
            ? { ...item, defaultValue: newValue }
            : item
        );
        handleSchemaValue(updatedList);
      }}
      style={{ width: "100%" }}
      disabled={!isEditMode}
    />
  </Grid>
);
/*istanbul ignore next */
const APISchemaTree = ({
  keyValueList,
  handleSchemaValue,
  clientFolderDropdown,
  eLabelDropdown,
  formik,
  isEditMode,
  sourceDropdown = [],
}) => {
  const reconstructedData = reconstructTree(keyValueList);
  const whenOnLeafNode = (fullKey) => {
    const parameterObj = keyValueList.find((x) => x.parameterName === fullKey);
    return (
      <Grid item xs={7} display="flex" flexDirection="row">
        <Grid item xs={0.2} pr={3} mt={1.8}>
          <ArrowCircleRightIcon sx={{ color: "#1aaefa" }} />
        </Grid>
        {renderSourceDropdown({
          parameterObj,
          fullKey,
          isEditMode,
          keyValueList,
          handleSchemaValue,
          sourceDropdown,
        })}

        {parameterObj?.source === 2 &&
          renderClientDropdown({
            parameterObj,
            fullKey,
            isEditMode,
            keyValueList,
            handleSchemaValue,
            clientFolderDropdown,
            formik,
          })}

        {parameterObj?.source === 1 &&
          renderElabelDropdown({
            parameterObj,
            fullKey,
            isEditMode,
            keyValueList,
            handleSchemaValue,
            eLabelDropdown,
            formik,
          })}

        {renderDefaultValueInput({
          parameterObj,
          fullKey,
          isEditMode,
          keyValueList,
          handleSchemaValue,
        })}
      </Grid>
    );
  };
  /*istanbul ignore next */
  const renderTree = (data, parentKey = "") => {
    if (!data || typeof data !== "object") return null;
    return Object.entries(data).map(([parameterName, value], index) => {
      const fullKey = parentKey
        ? `${parentKey}.${parameterName}`
        : parameterName;
      const nodeId = `${parentKey}-${index + 1}`;
      const isLeafNode = typeof value !== "object" || value === null;

      const label = (
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          style={{ width: "100%" }}
        >
          <Grid item xs={5}>
            <TextField
              value={parameterName}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
              size="small"
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "black",
                  height: "20px",
                },
                pointerEvents: "none",
              }}
              disabled
              fullWidth
            />
          </Grid>
          {isLeafNode && whenOnLeafNode(fullKey)}
        </Grid>
      );

      return (
        <TreeItem key={nodeId} nodeId={nodeId} label={label}>
          {typeof value === "object" && value !== null
            ? renderTree(value, fullKey)
            : null}
        </TreeItem>
      );
    });
  };

  return (
    <Grid
      container
      xs={12}
      spacing={0}
      margin={1}
      style={{
        display: "flex",
        flexDirection: "row",
        overflow: "auto",
      }}
      className="blue-field-section"
    >
      <Grid item xs={12}>
        <TreeView
          aria-label="API Schema Tree"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          sx={{
            overflowY: "auto",
            maxWidth: "100%",
            "& .MuiTreeItem-group": {
              marginLeft: "20px",
              borderLeft: "1px solid rgba(15, 1, 1, 0.93)",
              marginTop: "0px",
              marginBottom: "0px",
            },
          }}
        >
          {reconstructedData && renderTree(reconstructedData)}
        </TreeView>
      </Grid>
    </Grid>
  );
};

APISchemaTree.propTypes = {
  keyValueList: PropTypes.arrayOf(
    PropTypes.shape({
      parameterName: PropTypes.string.isRequired,
      value: PropTypes.any,
      source: PropTypes.number,
      clientDetails: PropTypes.number,
      eLabel: PropTypes.number,
      defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  handleSchemaValue: PropTypes.func.isRequired,
  clientFolderDropdown: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.string,
    })
  ),
  eLabelDropdown: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.string,
    })
  ),
  formik: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
    values: PropTypes.object,
    setValues: PropTypes.func,
  }),
  isEditMode: PropTypes.bool,
  sourceDropdown: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.string,
    })
  ),
};

APISchemaTree.defaultProps = {
  clientFolderDropdown: [],
  eLabelDropdown: [],
  formik: {},
  isEditMode: false,
  sourceDropdown: [],
};

export default React.memo(APISchemaTree);
